import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userAddToCollection from 'website/containers/user-action/userAddToCollection';
import userRating from 'website/containers/user-action/userRating';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import userFriendsRating from 'website/containers/user/userFriendsRating';
// faceBookRCWidget
import facebookWidgets from 'website/module/ui/facebookWidgets';

// bootstrap the application / store
applicationBootstrap().then(() => {
  // fb rc widget init
  facebookWidgets();

  // Social user Action
  userOpinion();
  userReviewLink();
  userAddToCollection();
  userFriendsRating();
  userRating();
  userWantToSee();

  socialActionsBootstrap();
});
